import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      fill="currentColor"
      d="m4.987 12.233 2.066 1.6c.267.267.867.4 1.267.4h2.533c.8 0 1.667-.6 1.867-1.4l1.6-4.866c.333-.934-.267-1.734-1.267-1.734h-2.666c-.4 0-.734-.333-.667-.8l.333-2.133c.134-.6-.266-1.267-.866-1.467-.534-.2-1.2.067-1.467.467L4.987 6.367"
    />
    <path
      stroke="currentColor"
      fill="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1.587 5.7c0-.933.4-1.267 1.333-1.267h.667c.933 0 1.333.334 1.333 1.267v6.533c0 .934-.4 1.267-1.333 1.267H2.92c-.933 0-1.333-.333-1.333-1.267V5.7Z"
    />
  </svg>
)
export default SvgComponent
